import { defineMessages } from 'react-intl';

const messages = defineMessages({
  msgTaskTimeRegistrationCreated: 'Registered {duration} for {relation} <br/> Click here to edit',
  msgTaskTimeRegistrationStarted: 'Started time registration on {task}',
  msgTimerRegistrationStarted: 'Started time registration',
  msgTaskTimeRegistrationStillRunning:
    'Time registration on {task} for {relation} is still running. <br/> Duration: {duration}',
  msgTaskTimeRegistrationDiscarded: 'Registration discarded (less than 1 minute)',
  msgNoRegistrationMadeDefaultTimeZero: 'No time was registred because the default duration is 0',
  msgNoResourceDefined: 'No resource defined',
  msgTaskEmailCancelled: "Because the mail was not sent, this task is returned to state 'to do'",
  taskMgmtSendMailTitle: 'By dragging this task directly to done, the mail was not send.',
  taskMgmtSendMailContent: 'Click here to send it anyway',
  msgTaskOfTypeConditionCannotBeSetInProgress: 'Task of type condition cannot be set in progress.',
});

export default messages;
